import { createStore } from "vuex";
import auth from "./auth";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: false,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showTransferNavbar: false,
    showFooter: true,
    showMain: true,
    layout: "default",
    // Initialize from localStorage for UI persistence, will be validated and synced from profile API
    environment: localStorage.getItem("environment") || "sandbox",
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    sidebarMinimize(state) {
      let sidenav_show = document.querySelector("#app");
      if (state.isPinned) {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav_show.classList.remove("g-sidenav-hidden");
        state.isPinned = true;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    setShowNavbar(state, payload) {
      state.showNavbar = payload;
    },
    setShowSidenav(state, payload) {
      state.showSidenav = payload;
    },
    setEnvironment(state, payload) {
      // Only allow valid environment values
      const validEnvironments = ['sandbox', 'production'];
      if (validEnvironments.includes(payload)) {
        state.environment = payload;
        // Save to localStorage for persistence across page reloads
        localStorage.setItem("environment", payload);
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    changeEnvironment({ commit, getters }, environment) {
      // Security check: only allow production if KYB is approved
      const statusKyb = getters['auth/statusKyb'];
      if (environment === 'production' && statusKyb !== 'approved') {
        // Force sandbox if KYB not approved
        commit("setEnvironment", "sandbox");
      } else {
        commit("setEnvironment", environment);
      }
    },
  },
  getters: {
    // Return the current environment state directly for UI display
    // Security validation is handled in the changeEnvironment action
    currentEnvironment: (state) => state.environment,
    isSandboxMode: (state) => state.environment === "sandbox",
    // Use auth module's statusKyb getter instead of localStorage
    statusKyb: (state, getters) => getters['auth/statusKyb'],
  },
  modules: {
    auth,
  },
});
